export class PlayerFilter {
    filterType: number;
    filterCondition: number;
    filterValue: number | undefined;
    filterStrValue: string | undefined;
    label: string | undefined;
    additional: number;
}